import React, { Component } from 'react';
import ReactTable from 'react-table';
import {ReactTableDefaults} from 'react-table';
// import 'react-table/react-table.css';

import TextWithTooltip from '../components/knowledgebase/TextWithTooltip';
class PeopleTable extends Component {


    constructor(props){
        super(props);
        this.handleMouseOver = this.handleMouseOver.bind(this);
        this.handleMouseOut = this.handleMouseOut.bind(this);

        this.state = {
            tooltipData: null,
        };
    }


    handleMouseOver(row){
        this.setState({ tooltipData: row });
    };

    handleMouseOut(){
        this.setState({ tooltipData: null });
    };

    render() {
        const columns = [
            {
                // No header, only display the label
                accessor: 'label',
                Cell: (row) => (<TextWithTooltip data={ row.original }/>),
            },
        ];

        const{ imageURL,label,id,citizenshipCountries,birthLocation}= this.state.tooltipData || {}
        return (
            <div>
                <div style={{ overflowX: 'auto', maxHeight: '200px', overflowY: 'auto' }}>
                    <ReactTable
                        data={this.props.personnelData}
                        columns={columns}
                        minRows={1}
                        showPagination={false} // Disable pagination
                        showHeaders={false} // Hide headers
                        className="personnel-table -highlight" // Remove striping by not using -striped
                        ThComponent={() => {null}}
                        getTdProps={(s, r) => ({onClick: (e) => {
                            this.props.onRowClick(r.original.id, r.original.type)
                        }})}
                        TheadComponent={() => null} // Hide the header row
                        TdComponent={ReactTableDefaults.TdComponent} // Hide the body row
                        customTheme={()=>({rows: {fontSize: '12px'}})}
                    />
                </div>
            </div>
        );
    }
}

export default PeopleTable;
